import { Table } from '@tanstack/react-table';
import { RequireExactlyOne } from 'type-fest';

import { Result, Status, Tbody, Td, Tr } from '@oaknorth/component-core-v2';
import { T } from '@oaknorth/util-intl';

type TableBodyProps<T extends object> = RequireExactlyOne<
  {
    table: Table<T>;

    /**
     * Javascript error object to display inside ErrorState
     */
    error?: Error | null;

    /**
     * Optional prop to use when a table object is unavailable to set the number of columns for
     * the error state to show. Required if `table` is not provided.
     */
    numberOfColumns: number;
  },
  'table' | 'numberOfColumns'
>;

export const TableError = <T extends object = {}>({ table, error, numberOfColumns }: TableBodyProps<T>) => {
  const amountVisibleColumns = table?.getVisibleLeafColumns().length || numberOfColumns;

  return (
    <Tbody>
      <Tr>
        <Td colSpan={amountVisibleColumns}>
          <Result status={Status.ERROR} title={T`table.error`} text={error?.message} />
        </Td>
      </Tr>
    </Tbody>
  );
};
